import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ae4c476c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ae4c476c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4c476c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae4c476c')) {
      api.createRecord('ae4c476c', component.options)
    } else {
      api.reload('ae4c476c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ae4c476c&scoped=true&", function () {
      api.rerender('ae4c476c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SIGRzOx1gJCY/JS/comp/PopupBox.vue"
export default component.exports